import React from 'react';
import InfoBox from '../UI/InfoBox';

import useGetFeature from '../../hooks/useGetFeature';

type Props = {
  flag: string,
  className: string,
  withInfoBox?: boolean,
  color?: string
};

const NotificationBar = ({
  flag,
  className,
  withInfoBox = false,
  color = 'green'
}: Props) => {
  const feature = useGetFeature(flag);

  if (!feature || feature.enabled === false) {
    return null;
  }

  const copy = feature.variantAttachment.value;

  if (!copy) {
    return null;
  }
  /* eslint-disable react/no-danger */
  const styleValue = feature.variantAttachment.style;
  const Content = () => (
    <div
      className={`${className}--content`}
      dangerouslySetInnerHTML={{ __html: copy }}
    />
  );
  return (
    <div className={className}>
      {withInfoBox ? (
        <InfoBox color={styleValue || color}>
          <Content />
        </InfoBox>
      ) : (
        <Content />
      )}
    </div>
  );
};

export default NotificationBar;
